import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Unit } from '../models/unit';
import { updateUnitEndpoint } from './const';

export const updateUnit = (unit: Unit) => {
    return getHttpClient().post({ url: updateUnitEndpoint, data: JSON.stringify(unit) });
};
